import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { EntrancePassBuilding } from "./data-contracts";

export const getAppEntrancepassGetbuildings = (params?: IFetchConfig) =>
  fetch<EntrancePassBuilding[]>("GET", `buildings/entrance`, null, params);
